export enum SensorUnitType {
  Current = 0,
  Potential = 1,
}
